'use client';

import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import { useState } from 'react';
import { Button } from '@shared/ui-components/button/button';
import { ButtonVariant } from '@shared/ui-components/button/buttonVariant';
import { ModalTrigger } from '@shared/ui-components/modal/modal';
import { LockIconZoomedIn } from '@shared/ui-components/svgs';
import { Dialog } from '../../../../../../components/dialog/dialog';
import { useUserContext } from '../../../../../../components/providers/user-context';
import { HOMEPAGE_PATH } from '../../../../../../utils/constants/local-paths';
import { loginHandler } from '../../../../../../utils/helpers/login-handler';
import styles from './locked-resource-prompt.module.scss';
type UseLockedResourcePromptProps = {
  cmsContent: {
    cancelLabel: string;
    lockedResourceModalHeading: string;
    lockedResourceModalSubheading: string;
    loginLinkLabel: string;
  };
  isResourceLocked: boolean;
  resourceUrl: null | string | undefined;
};
export const useLockedResourcePrompt = t0 => {
  const $ = _c(14);
  const {
    cmsContent,
    isResourceLocked,
    resourceUrl
  } = t0;
  const locale = useLocale();
  const [isLockedResourcePromptVisible, setIsLockedResourcePromptVisible] = useState(false);
  const {
    isAuthenticated
  } = useUserContext();
  const shouldLockedResourcePromptBeShown = !isAuthenticated && isResourceLocked;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsLockedResourcePromptVisible(false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const closeLockedResourcePrompt = t1;
  let t2;
  if ($[1] !== shouldLockedResourcePromptBeShown) {
    t2 = () => {
      if (shouldLockedResourcePromptBeShown) {
        setIsLockedResourcePromptVisible(true);
      }
    };
    $[1] = shouldLockedResourcePromptBeShown;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onResourceClick = t2;
  let t3;
  if ($[3] !== locale || $[4] !== resourceUrl) {
    t3 = () => {
      loginHandler({
        authorizationParameters: {
          ui_locales: locale
        },
        options: {
          redirectTo: resourceUrl || HOMEPAGE_PATH
        }
      });
    };
    $[3] = locale;
    $[4] = resourceUrl;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onSignInClick = t3;
  let t4;
  if ($[6] !== cmsContent || $[7] !== isLockedResourcePromptVisible || $[8] !== onSignInClick) {
    t4 = () => <ModalTrigger isOpen={isLockedResourcePromptVisible}>{() => <Dialog onModalClose={closeLockedResourcePrompt}><div className={styles["locked-resource-prompt"]}><div className={styles["locked-resource-prompt__content"]}><LockIconZoomedIn className={styles["locked-resource-prompt__lock-icon"]} /><h3 className={styles["locked-resource-prompt__heading"]}>{cmsContent.lockedResourceModalHeading}</h3><p className={styles["locked-resource-prompt__subheading"]}>{cmsContent.lockedResourceModalSubheading}</p></div><div className={styles["locked-resource-prompt__actions"]}><Button onClick={onSignInClick}>{cmsContent.loginLinkLabel}</Button><Button onClick={closeLockedResourcePrompt} variant={ButtonVariant.Secondary}>{cmsContent.cancelLabel}</Button></div><div className={styles["locked-resource-prompt__actions--secondary"]}><Button onClick={closeLockedResourcePrompt} variant={ButtonVariant.Secondary}>{cmsContent.cancelLabel}</Button><Button onClick={onSignInClick}>{cmsContent.loginLinkLabel}</Button></div></div></Dialog>}</ModalTrigger>;
    $[6] = cmsContent;
    $[7] = isLockedResourcePromptVisible;
    $[8] = onSignInClick;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== onResourceClick || $[11] !== shouldLockedResourcePromptBeShown || $[12] !== t4) {
    t5 = {
      onResourceClick,
      renderLockedResourcePrompt: t4,
      shouldLockedResourcePromptBeShown
    };
    $[10] = onResourceClick;
    $[11] = shouldLockedResourcePromptBeShown;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};